/* eslint-disable no-console */
import _ from 'underscore';

import { addNewTooltipsToButtonGroup } from '../tooltips';
import { getItemsFromAccount, removeItemFromAccount } from '../consumer-account/storage-actions';
import { setupCartActions, updateCartState } from '../cart-helpers';

import InitSwatchOrderingUtils from '../swatch-ordering';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const template =
  `<div class="col mb-5">
    <div class="product-swatch swatch-card">
      <div class="swatch-image-wrapper">
        <button class="swatch-image">
          <div class="object-fit site-image-wrapper">
            <img class="site-image" alt="{{ colorName }}" src="{{ imageUrl }}" />
          </div>
          {{ newBadge() }}
        </button>
        <button class="swatch-detail-modal-btn" data-colorName="{{ colorName }}" data-productName="{{ tileName }}" data-imgsrc="{{ imageUrl }}" data-imgalt="">
          <span class="link-wrapper">
            <span class="more-link pl-4">+ View Detail</span>
          </span>
        </button>
      </div>
      <div class="swatch-content">
        <div class="heading-xs mb-2">{{ colorName }}</div>
        {{ displayMessageDiv() }}
        <div class="d-flex justify-content-between pt-2">
          <button class="btn-secondary add-to-cart-btn swatch-cart-btn btn-sm flex-fill mr-4" data-swatchKey="{{ swatchKey }}" data-colorname="{{ colorName }}"><span class="sr-only">Add </span>Free Sample<span class="sr-only">Of {{ colorName }} To Cart</span></button>
          <button class="btn-secondary remove-from-favorites-btn swatch-btn circle-btn is-active" aria-label="Remove swatch from My Favorites" data-asset-id="{{ assetId }}" data-type="swatch" data-tooltip-id="tooltip-swatch-{{ assetId }}"><span class="icon"></span></button>
          <div class="tooltip" id="tooltip-swatch-{{ assetId }}">
            <div class="tooltip-inner">
              <p class="body-md">Remove<span class="sr-only">{{ colorName }} Swatch</span> From Favorites</p>
            </div>
            <div class="tooltip-caret"></div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const noItemsTemplate =
  `<div class="row">
    <div class="col">
      <div class="rounded-box bg-gray p-5">
        {{ content }}
      </div>
    </div>
  </div>`;

const newLabelTemplate = '<div class="product-callout-box">New!</div>';

const displayMessageTemplate = '<p class="body-sm display-message mb-2">{{ displayMessage }}</p>';

const templateVals = _.template(template);
const noItemsTemplateVals = _.template(noItemsTemplate);
const displayMessageTemplateVals = _.template(displayMessageTemplate);

let items = [];
// let products = [];
// let productParamIter = 0;
let swatchData = [];

const props = {
  removePageItemById: null,
  updateSwatchbook: null,
  enqueuePdfUtilsData: null,
};

const hasItems = () => (
  items.length !== 0
);

const update = () => {
  const { NoSwatchesContent } = window;
  const div = document.createElement('div');
  const selector = document.querySelector('.swatches-content');
  if (items.length === 0) {
    const compiled = noItemsTemplateVals({
      content: NoSwatchesContent,
    });
    div.innerHTML = compiled;
    selector.innerHTML = '';
    selector.appendChild(div.firstChild);
  }
  props.updateSwatchbook();
};

const render = () => {
  // Map data
  items = swatchData.swatches.map(item => ({
    assetId: item['swatch-id'],
    imageUrl: `${window.WidenSwatchBaseUrl}${item['widen-url']}`,
    colorName: item['color-name'],
    colorNumber: item['color-number'],
    colorRange: item['color-range'],
    displayMessage: item['display-message'],
    displayMessageDiv: () => {
      if (item['display-message'] !== '') {
        return displayMessageTemplateVals({
          displayMessage: item['display-message'],
        });
      }
      return '';
    },
    newBadge: () => {
      if (item['new-swatch']) {
        const newLabelTemplateVals = _.template(newLabelTemplate);
        return newLabelTemplateVals();
      }
      return '';
    },
    newSwatch: item['new-swatch'],
    partNumber: item['part-number'],
    swatchKey: item['swatch-key'],
    tileName: item['tile-name'].replace(/"/gi, '&quot;'),
    type: 'swatch', // for pdfutils
    id: item['swatch-key'], // for pdfutils
  }));
  // Display saved content
  if (items.length > 0) {
    const selector = document.querySelector('.swatches-content');
    const div = document.createElement('div');
    div.classList = 'row row-cols-xs-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-lg-6';
    selector.innerHTML = '';
    items.forEach((item) => {
      const itemDiv = document.createElement('div');
      const compiled = templateVals(item);
      itemDiv.innerHTML = compiled;
      div.appendChild(itemDiv.firstChild);
    });
    selector.appendChild(div);
    // Add tooltips
    addNewTooltipsToButtonGroup({
      btns: selector.querySelectorAll('[data-tooltip-id]'),
    });
  }
  props.enqueuePdfUtilsData(items);
  update();
};

const removeFromFavoritesEventHandlers = () => {
  const removeFromFavoritesBtns = document.querySelectorAll('.remove-from-favorites-btn.swatch-btn');
  if (removeFromFavoritesBtns.length === 0) {
    return;
  }
  const productSwatchDivs = document.querySelectorAll('.product-swatch');
  [].map.call(productSwatchDivs, (swatch) => {
    const btn = swatch.querySelector('.remove-from-favorites-btn');
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      btn.classList.add('btn-disabled');
      // Remove
      const assetId = btn.getAttribute('data-asset-id');
      removeItemFromAccount('swatch', assetId, () => {
        // Remove div
        swatch.parentNode.remove();
        props.removePageItemById(items, assetId);
        update();
      });
    });
  });
};

const onLoaded = (data) => {
  swatchData = data;
  render();
  removeFromFavoritesEventHandlers();
  InitSwatchOrderingUtils();
  updateCartState();
  setupCartActions();
};

const init = (options) => {
  const {
    enqueuePdfUtilsData,
    removePageItemById,
    updateSwatchbook,
  } = options;
  props.enqueuePdfUtilsData = enqueuePdfUtilsData;
  props.removePageItemById = removePageItemById;
  props.updateSwatchbook = updateSwatchbook;
  getItemsFromAccount('swatch', onLoaded);
};

export {
  hasItems,
  init,
  onLoaded,
};
/* eslint-enable no-console */
